import React from 'react';
import { Link } from '~/UI/Button';
import { ReactNode } from 'react';

interface HelpLinkProps {
	className: string;
	children?: null | ReactNode;
}

export function HelpLink({ className, children }: HelpLinkProps) {
	return (
		<Link className={className} to='/help/irp'>
			About IRP calculation{children && '\u00A0'}
			{children || null}
		</Link>
	);
}
